export const unreadCountScreenReaderOnlyText = "l3c";
export default {unreadCountScreenReaderOnlyText};